import { OfferCategoryApiClient } from '@fourthwall/services/dist/OfferCategoryApiClient'
import { createQueryHook } from '@fourthwall/utils'

export const useSearchOfferCategoriesQuery = createQueryHook(
  OfferCategoryApiClient.searchOfferCategories,
  {
    queryKey: ['searchOfferCategories'],
  },
)
